require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/core-js/library/modules/es7.symbol.observable.js
// module id = 643
// module chunks = 20